import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Code — left/right brackets with a text cursor blinking between them.
 *  The cursor uses a square-ish opacity step (not a smooth fade) to match
 *  a real terminal caret. */
export function IcnCode(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="code">
      <path d="M5 4L2 8l3 4" />
      <path d="M11 4l3 4-3 4" />
      <line x1="8" y1="5" x2="8" y2="11">
        {animate && (
          <animate
            attributeName="opacity"
            values="1;1;0;0;1"
            keyTimes="0;0.45;0.5;0.95;1"
            dur="1.2s"
            repeatCount="indefinite"
          />
        )}
      </line>
    </Svg>
  );
}
